import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { PlusCircleIcon, MinusCircleIcon, ShoppingCartIcon } from '@heroicons/react/24/outline';
import { useCarts, useCartsDispatch } from '../contexts/CartContext';

const imgurl = `${process.env.REACT_APP_URL}/image/products`


function CardProduct({pd, enable, setPd, open, setOpen}) {
    const carts = useCarts();
    const dispatch = useCartsDispatch();

    // console.log(pd,open);

    const setCart = async (pd) => {
        // console.log(pd)
    
        const cartitem = carts.filter((cart) => cart.pdid === pd.id);
        if (cartitem && cartitem.length > 0) {
          dispatch({
            type: 'changed',
            pdid: pd.id,
            name: pd.name,
            price: pd.price,
            quantity: pd.quantity? pd.quantity : 1,
            imageSrc: pd.img,
    
          });
          
        } else {
          dispatch({
            type: 'added',
            id: pd.id,
            pdid: pd.id,
            name: pd.name,
            price: pd.price,
            quantity: pd.quantity? pd.quantity : 1,
            imageSrc: pd.img,
    
          });
        };
      };
    
    const handleClose = () => {
      setOpen(false);
    };
    
  
    // console.log(pd);
  
    
    const Descpt = (de) => {
        // console.log(de);
        const txt = de.de.split("-");
        // console.log(txt);
        return ( 
          <ul className="list-inside list-disc p-4 text-sm sm:text-md">
            {txt.map((de,i) => (
              <li key={i} className="first:list-none first:mb-2 last:list-none last:px-2 last:mt-2">
                  {de}
              </li>
            ))}
          </ul>
        )
    }
  
  return (
    <Dialog
        fullWidth={true}
        maxWidth='sm'
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        {pd && (
          <div>
            <div className="flex w-full p-4 gap-2">
              <div>
                <img src={`${imgurl}/${pd.img}`} alt="" className="w-36 sm:w-72 object-contain mx-auto rounded-xl" />

              </div>
              <div>
                <span className="text-center text-lg sm:text-2xl text-gray-600"> {pd.name}</span>
                <Descpt de={pd.description} />
                
              </div>
            </div>

            <div className="grid mx-auto p-4 px-6 w-full content-between">
              <div className="flex flex-1 items-end justify-between text-sm">
                <div className="flex">
                  <PlusCircleIcon  
                    onClick={() => {
                      setPd((prev) => ({
                        ...prev,
                        quantity: prev.quantity? prev.quantity + 1 : 2,
                      }));
                    }}
                    className="h-5  w-5 text-gray-600 hover:text-green-500 hover:cursor-pointer" 
                  />                                
                  <p className="px-2 text-sm font-medium text-gray-500">{pd.quantity? pd.quantity : 1}</p>
                  <MinusCircleIcon 
                    onClick={() => {
                      setPd((prev) => ({
                        ...prev,
                        quantity: prev.quantity? prev.quantity - 1 : 0,
                      }));
                    }}
                    className="h-5 w-5 text-gray-600 hover:text-red-500 hover:cursor-pointer"
                  />
                  {enable==='true' && <ShoppingCartIcon 
                    className="h-6 w-6 ml-2 text-teal-500 inline-block hover:text-teal-700 hover:cursor-pointer"
                    onClick={() => setCart(pd)}
                  />
                  }
                </div>
                <div className="flex">
                  <p className="flex items-center justify-end p-1 text-md font-medium text-gray-300 bg-emerald-700 rounded-full">ราคา: {pd.price}฿</p>
                </div>
              </div>            
            </div>
          </div>
        )}
      </Dialog>
  )
}

export default CardProduct